export const getGuaranteesErrorMessage = (error: unknown): string => {
  const value = error as { message?: unknown; data?: { message?: unknown } } | undefined;
  return typeof value?.message === 'string'
    ? value.message
    : typeof value?.data?.message === 'string'
      ? value.data.message
      : 'Сервіс тимчасово недоступний';
};
export const isGuaranteesApplicationVersionMismatch = (error: unknown): boolean => {
  const value = error as
    { code?: string; errorCode?: string; data?: { code?: string; errorCode?: string } } | undefined;
  return [value?.code, value?.errorCode, value?.data?.code, value?.data?.errorCode].includes(
    'APPLICATION_VERSION_MISMATCH'
  );
};
